import { useNavigate } from 'react-router';

const useNavigationService = () => {
  const navigate = useNavigate();

  return {
    navegarParaEdicao: (id: string | number) => {
      navigate(`/loader/${id}`);
    },
    navegarParaListagem: () => {
      navigate(`/`);
    },
    navegarParaDashboard: () => {
      navigate(`/dashboard`);
    },
  };
};

export default useNavigationService;
